import React from 'react';
import { config } from '@keytrade/functions';

const { list: colors } = config.colors;

const LinkedInIcon: React.FC = () => {
  return (
    <svg
      width='21'
      height='23'
      viewBox='0 0 21 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-label='LinkedIn'
    >
      <path
        d='M4.89467 3.19362C4.89894 3.74248 4.6871 4.27097 4.30491 4.66492C3.92273 5.05886 3.40089 5.28662 2.85216 5.29899C2.30458 5.27889 1.78564 5.04921 1.40258 4.65737C1.01953 4.26554 0.801636 3.74154 0.793945 3.19362C0.81775 2.65981 1.04364 2.155 1.42585 1.78156C1.80804 1.40812 2.31794 1.19397 2.85216 1.18254C3.38485 1.19419 3.89294 1.40886 4.27259 1.78268C4.65224 2.15649 4.87478 2.66121 4.89467 3.19362ZM1.01391 9.03835C1.01391 7.82856 1.78378 8.0171 2.85216 8.0171C3.92056 8.0171 4.67472 7.82856 4.67472 9.03835V20.8221C4.67472 22.0476 3.90485 21.7962 2.85216 21.7962C1.7995 21.7962 1.01391 22.0476 1.01391 20.8221V9.03835Z'
        stroke={colors.BlueDawn}
        strokeWidth='1.56085'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.84839 9.03853C7.84839 8.36292 8.09977 8.11154 8.49256 8.03299C8.88536 7.95442 10.2365 8.03299 10.7079 8.03299C11.1792 8.03299 11.3678 8.80284 11.3521 9.38418C11.7553 8.84307 12.2906 8.41446 12.9068 8.13937C13.523 7.86427 14.1994 7.75191 14.8715 7.81302C15.5314 7.77267 16.1925 7.87162 16.8117 8.10342C17.4308 8.33521 17.9944 8.69469 18.4655 9.15848C18.9368 9.62227 19.305 10.18 19.5466 10.7954C19.7882 11.4109 19.8976 12.0703 19.8677 12.7308V20.7751C19.8677 22.0006 19.1136 21.7492 18.0452 21.7492C16.9768 21.7492 16.2227 22.0006 16.2227 20.7751V14.4905C16.2503 14.167 16.2081 13.8414 16.0987 13.5358C15.9893 13.2301 15.8154 12.9516 15.5889 12.7191C15.3623 12.4865 15.0884 12.3055 14.7857 12.1882C14.483 12.071 14.1586 12.0202 13.8345 12.0394C13.512 12.0313 13.1913 12.0917 12.8939 12.2167C12.5964 12.3417 12.3289 12.5285 12.1091 12.7647C11.8893 13.0009 11.7221 13.2811 11.6187 13.5867C11.5153 13.8923 11.4779 14.2164 11.5092 14.5376V20.8222C11.5092 22.0478 10.7393 21.7964 9.67093 21.7964C8.60255 21.7964 7.84839 22.0478 7.84839 20.8222V9.03853Z'
        stroke={colors.BlueDawn}
        strokeWidth='1.56085'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LinkedInIcon;
